import {create} from './create';
import * as set from './set';
import * as validate from './validate';

export default {create, set, validate};